import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class IrvTarifeListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "IrvTarifeListe";
        super(baseUrl);
    }


    getIrvTarife(yili?: number,) {

        return this.get("", { params: { yili: yili } });
    }
}
export default new IrvTarifeListeAPI();
